import {SET_SPARES_LEAD_STATUS_LIST} from "../../Actions/ActionConstants";

const LeadStatusListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_LEAD_STATUS_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default LeadStatusListReducer
